var WkSellerList = $.noConflict(true);
(function($){
  if(WkSellerList('.wk-seller-listing-responsive').length){
    WkSellerList('.wk-seller-listing-responsive').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: false,
      prevArrow: `
      <button class="slick-prev product__media-arrow button-arrow motion-reduce"
        aria-label="Previous" type="button">
        <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
          <polyline points="16 4 8 12 16 20"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"/>
        </svg>
      </button>`,

      nextArrow: `
      <button class="slick-next product__media-arrow button-arrow motion-reduce"
        aria-label="Next" type="button">
        <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
          <polyline points="8 4 16 12 8 20"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"/>
        </svg>
      </button>`,

      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 8,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1510,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }
    
})(WkSellerList);